// @flow

export function getExpiryMonthFromCardExpiration(expiryDate: string): string {
  return expiryDate.substring(0,2);
}

export function getExpiryYearFromCardExpiration(expiryDate: string): string {
  return expiryDate.substring(3);
}
